export default "__VITE_ASSET__CJmE3VB3__"